import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import DataService from '../../services/data.service';
import LoaderOverlay from '../common/loader.component';
import { useNavigate } from 'react-router-dom';
import Confirmation from '../common/confimation.component';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';

const BookingQuestions = () => {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [row, setCurrentRow] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    getQuestions();
  }, []);

  const getQuestions = () => {
    setLoading(true);
    DataService.getBookingQuestions()
      .then((response) => {
        setQuestions(response.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleAddQuestion = () => {
    navigate('/add-booking-question');
  };

  const deleteData = (row) => {
    setCurrentRow(row);
    setModalShow(true);
  };

  const updateStatus = () => {
    if (!row) return;

    setLoading(true);
    DataService.deleteBookingQuestion({ id: row.id })
      .then((response) => {
        toast.success('Booking Question Deleted Successfully.');
        getQuestions();
        setLoading(false);
        setModalShow(false);
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.response?.data?.error || 'Failed to delete question');
        setLoading(false);
        setModalShow(false);
      });
  };

  const columns = [
    {
      name: 'ID',
      selector: row => row.id,
      sortable: true,
      width: '80px',
    },
    {
      name: 'Question',
      selector: row => row.question,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Type',
      selector: row => row.input_type,
      sortable: true,
      width: '120px',
    },
    {
      name: 'Required',
      selector: row => row.is_required ? 'Yes' : 'No',
      sortable: true,
      width: '100px',
    },
    {
      name: 'Order',
      selector: row => row.display_order,
      sortable: true,
      width: '80px',
    },
    {
      name: 'Actions',
      cell: row => (
        <div className="d-flex gap-2 align-items-center">
          <FontAwesomeIcon
            icon={faEdit}
            className="text-primary"
            style={{ cursor: 'pointer', fontSize: '14px' }}
            onClick={() => editData(row)}
          />
          <FontAwesomeIcon
            icon={faTrash}
            className="text-danger"
            style={{ cursor: 'pointer', fontSize: '14px' }}
            onClick={() => deleteData(row)}
          />
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      width: '100px',
    }
  ];

  const editData = (data) => {
    navigate('/edit-booking-question', { state: { data } });
  };

  return (
    <>
      <LoaderOverlay loading={loading} />

      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>Booking Questions</h4>
        <button className="btn btn-success" onClick={handleAddQuestion}>Add Question</button>
      </div>

      <DataTable
        columns={columns}
        data={questions}
        pagination
        highlightOnHover
        striped
        responsive
        noHeader
      />

      <Confirmation
        show={modalShow}
        onHide={() => setModalShow(false)}
        onSave={updateStatus}
        handleClose={() => setModalShow(false)}
      />
    </>
  );
};

export default BookingQuestions;